module.exports = __webpack_public_path__ + "img/proximanova-light-webfont.71f74e90.svg";